/**
 * Buscador del banner (lupa desplegable).
 * Autónomo — no toca el buscador del header. Usa la sección
 * ecom-predictive-search como dropdown de resultados.
 */
class BannerSearch extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector("[data-banner-search-toggle]");
    this.input = this.querySelector("[data-banner-search-input]");
    this.results = this.querySelector("[data-banner-search-results]");
    this.form = this.querySelector("form");
    this.predictiveUrl = this.dataset.predictiveUrl;
    this.cache = {};
    this.bind();
  }

  bind() {
    this.toggle.addEventListener("click", () => this.toggleOpen());

    this.input.addEventListener("input", this.debounce(() => this.search(), 300));

    // Enter en el input vacío no busca; con texto, deja que el form vaya a /search
    this.form.addEventListener("submit", (e) => {
      if (!this.input.value.trim()) e.preventDefault();
    });

    // Cerrar al clickear afuera
    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) this.close();
    });
    // Cerrar con Escape
    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.close();
    });
  }

  toggleOpen() {
    const isOpen = this.classList.toggle("is-open");
    if (isOpen) {
      this.input.focus();
    } else {
      this.clearResults();
    }
  }

  close() {
    this.classList.remove("is-open");
    this.clearResults();
  }

  clearResults() {
    this.results.innerHTML = "";
  }

  async search() {
    const q = this.input.value.trim();
    if (!q) {
      this.clearResults();
      return;
    }
    if (this.cache[q]) {
      this.results.innerHTML = this.cache[q];
      return;
    }
    const url =
      `${this.predictiveUrl}?q=${encodeURIComponent(q)}` +
      `&resources[type]=product,collection,page,article` +
      `&resources[limit]=6` +
      `&section_id=ecom-predictive-search`;
    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const text = await res.text();
      const node = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-ecom-predictive-search");
      const html = node ? node.innerHTML : "";
      this.cache[q] = html;
      this.results.innerHTML = html;
    } catch (e) {
      this.clearResults();
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("banner-search", BannerSearch);
